import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as common from '../../../../common'

import { Node } from './node'

/**
 * Represents a concrete value that requires no further evaluation
 */

export class ForValue<T = unknown> extends Node<T> {
  constructor(
    public readonly value: T,
    public readonly type: common.value.types.Intrinsic.Of<T> = common.value.types.Intrinsic.inferFrom(
      // NOTE: It may not actually be the right type, but we should at least
      // try
      value as Extract<T, common.value.Raw>,
    ),
  ) {
    super()
  }
}
export namespace ForValue {
  export const isForValue: TypeChecker<ForValue> = TypeChecker.Factory.instance(
    ForValue,
  ).usingAlias('dms.data.expression.node.ForValue')
  export const assertIsForValue: TypeAsserter<ForValue> =
    TypeAsserter.Factory.from(isForValue)
}
